import {
  Skeleton,
  TextField,
  Select,
  MenuItem
} from "@mui/material"
import {
  FilterOption
} from "../../../components"
import AutoCompleteSearch from "../AutoCompleteSearch"
import {
  WhoActionContainer,
  FilterOptionsContainer,
  NotificationContainer,
  NotificationStatusContainer,
  SeverityLevelContainer,
  TextCount
} from "./styled"
import { useTranslation } from "react-i18next"

const AnnotationTab = ({
  userList,
  users,
  loading,
  selectUser,
  removeUserFromList,
  text,
  setText,
  severity,
  setSeverity,
  SEVERITY,
  status,
  setStatus,
  STATUS
}) => {
  const onType = e => setSeverity(e.target.value)
  const { t } = useTranslation('common')

  return (
    <>
      <WhoActionContainer>
        <span>{t('admin_actions_modal.user_select')}</span>
        <AutoCompleteSearch options={userList} onSelect={selectUser} />
        <FilterOptionsContainer>
          {loading ? (
            <>
              <Skeleton>
                <FilterOption isSelected dismissable name="Jakob Carder" />
              </Skeleton>
              <Skeleton>
                <FilterOption isSelected dismissable name="Jakob Carder" />
              </Skeleton>
            </>
          ) : (
            users.map(({ id, name }) => (
              <FilterOption
                key={id}
                isSelected
                dismissable
                name={name}
                onClick={() => removeUserFromList({ id })}
              />
            ))
          )}
        </FilterOptionsContainer>
      </WhoActionContainer>

      <NotificationContainer>
        <span>{t('admin_actions_modal.annotation')}</span>
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={3}
          placeholder={t('admin_actions_modal.user_select_placeholder')}
          onChange={e => setText(e?.target?.value)}
          value={text}
        />
        <TextCount length={text?.length}>
          {text?.length || 0} {t('admin_actions_modal.text_count')}
        </TextCount>
      </NotificationContainer>

      <NotificationStatusContainer>
        <SeverityLevelContainer>
          <span>{t('admin_actions_modal.severity_level_header')}</span>
          <Select
            labelId="severity-level-label"
            id="severity-level"
            value={severity}
            onChange={onType}
          >
            <MenuItem value={SEVERITY.LOW}>{t('admin_actions_modal.low')}</MenuItem>
            <MenuItem value={SEVERITY.MEDIUM}>{t('admin_actions_modal.medium')}</MenuItem>
            <MenuItem value={SEVERITY.HIGH}>{t('admin_actions_modal.high')}</MenuItem>
          </Select>
        </SeverityLevelContainer>
        <SeverityLevelContainer>
          <span>{t('admin_actions_modal.annotation_status')}</span>
          <Select
            labelId="anotation-status-label"
            id="anotation-status"
            value={status}
            onChange={e => setStatus(e.target.value)}
          >
            <MenuItem value={STATUS.PENDING}>{t('admin_actions_modal.pending')}</MenuItem>
            <MenuItem value={STATUS.ACKNOWLEDGED}>{t('admin_actions_modal.acknowledged')}</MenuItem>
            <MenuItem value={STATUS.COMPLETED}>{t('admin_actions_modal.concluded')}</MenuItem>
          </Select>
        </SeverityLevelContainer>
      </NotificationStatusContainer>
    </>
  )
}

export default AnnotationTab
